import { Component, inject, InjectionToken } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { SignaturePadComponent } from '@fullyops/shared/components/signature-pad/signature-pad.component';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextCapPipe } from 'angular-i18next';

export interface ReportSignatureArguments {
  onSign(signature: Blob, comments: string): void;
  onCancel(): void;
}

export const REPORT_SIGNATURE_FORM_TOKEN =
  new InjectionToken<ReportSignatureArguments>('REPORT_SIGNATURE_FORM');

@Component({
  selector: 'fo-report-signature-form',
  imports: [
    MaterialModule,
    ReactiveFormsModule,
    I18NextCapPipe,
    SignaturePadComponent,
  ],
  templateUrl: './report-signature-form.component.html',
  styleUrl: './report-signature-form.component.scss',
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
})
export class ReportSignatureFormComponent {
  private args = inject(REPORT_SIGNATURE_FORM_TOKEN);

  protected signature?: Blob;
  protected commentField = new FormControl('', { nonNullable: true });

  protected onSignatureChange(s: Blob): void {
    this.signature = s;
  }

  protected onClickSign(): void {
    this.args.onSign(this.signature, this.commentField.value);
  }

  protected onClickCancel(): void {
    this.args.onCancel();
  }
}
